import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styles from "../../styles/ResetPassword.module.css";
import { resetPassword } from "../../api/authService";
import { FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import { CircularProgress } from "@mui/material";

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (newPassword.length < 8) {
      setError("A senha deve ter no mínimo 8 caracteres.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("As senhas não coincidem.");
      return;
    }

    try {
      setLoading(true);
      await resetPassword(token, newPassword);
      setSuccess("Senha redefinida com sucesso! Você será redirecionado...");
      setTimeout(() => navigate("/login"), 3000);
    } catch {
      setError("Erro ao redefinir a senha. O token pode ser inválido ou expirado.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.resetPasswordContainer}>
      <h1>Redefinir Senha</h1>
      <p>Por favor, insira sua nova senha.</p>

      {error && <p className={styles.errorMessage}>{error}</p>}
      {success && <p className={styles.successMessage}>{success}</p>}

      <form onSubmit={handleSubmit} className={styles.resetPasswordForm}>
        <div className={styles.inputGroup}>
          <FaLock className={styles.inputIcon} />
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Nova Senha"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
          <span className={styles.togglePassword} onClick={togglePasswordVisibility}>
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        <div className={styles.inputGroup}>
          <FaLock className={styles.inputIcon} />
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Confirme a Nova Senha"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit" className={styles.resetButton} disabled={loading}>
          {loading ? <CircularProgress size={24} color="inherit" /> : "Redefinir Senha"}
        </button>
      </form>
    </div>
  );
}

export default ResetPassword;
